'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidStarOutline = function IoAndroidStarOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.6 16.4l-8.6 7.5 2.5 11.1-9.7-5.9-9.8 5.9 2.6-11.1-8.6-7.5 11.3-0.9 4.5-10.5 4.4 10.5z m-14.5 10.6l4.7 2.8-1.3-5.3-0.3-1.5 1.1-1 4.2-3.6-5.5-0.4-1.5-0.2-0.6-1.4-2.1-5-2.1 5-0.7 1.4-1.4 0.2-5.5 0.4 4.1 3.6 1.2 1-0.4 1.5-1.2 5.3 4.7-2.8 1.3-0.8z' })
        )
    );
};

exports.default = IoAndroidStarOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-star-outline.js
// module id = 2145
// module chunks = 0